// extracted by mini-css-extract-plugin
module.exports = {"leftArr":"Customstackedcarousel_leftArr__394wG","rightArr":"Customstackedcarousel_rightArr__Ad9yf","stackedCarouselDetails":"Customstackedcarousel_stackedCarouselDetails__3Y8-L"};